import React from 'react';
import type { OptionProps, SingleValueProps } from 'react-select';
import { components } from 'react-select';
import Badge from '../../components/Badge';
import type { ProvisionType } from '../../graphql/generated/graphqlTypes';
import { userBadgeColors } from '../../user/profile/UserBadge';
import styles from './ProvisionTypeSelectOption.module.scss';

interface ProvisionTypeSelectValueProps {
  data: {
    description: string;
    value: ProvisionType;
  };
}

const ProvisionTypeSelectValue = ({
  data: { description, value },
}: ProvisionTypeSelectValueProps) => (
  <div className={styles.value}>
    <div className={styles.badgeWrapper}>
      <Badge
        color={userBadgeColors[value as keyof typeof userBadgeColors]}
        inline={false}
      >
        {value}
      </Badge>
    </div>
    {description}
  </div>
);

type ProvisionTypeSelectOptionProps = Omit<
  OptionProps<ProvisionTypeSelectValueProps['data'], true>,
  'data'
> &
  ProvisionTypeSelectValueProps;

export const ProvisionTypeSelectOption = (
  props: ProvisionTypeSelectOptionProps,
) => (
  <components.Option {...props}>
    <ProvisionTypeSelectValue {...props} />
  </components.Option>
);

type ProvisionTypeSelectSingleValueProps = SingleValueProps<{
  description: string;
  value: ProvisionType;
}>;

export const ProvisionTypeSelectSingleValue = (
  props: ProvisionTypeSelectSingleValueProps,
) => (
  <components.SingleValue {...props}>
    <ProvisionTypeSelectValue {...props} />
  </components.SingleValue>
);
